export default __webpack_public_path__ + "static/CPdetail-image-videostill-bkgd-Earnell-4d9effe76a0f5468186107a9f4ab7ea4.jpg";